<template>
  <v-dialog :value="open" persistent max-width="900px">
    <v-card>
      <v-card-text>
        <v-container>
          <h1 v-if="edit">{{ $t('project.edit') }}</h1>
          <h1 v-else>{{ $t('project.create') }}</h1>
          <v-row>
            <v-col cols="8" sm="6" md="4">
              <v-text-field
                v-model="project.name"
                outlined
                ref="projectName"
                :label="$t('project.projectName')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="4" sm="6" md="4">
              <v-autocomplete
                :loading="isAccountLoading"
                :label="$t('project.account')"
                :rules="[rules.required]"
                outlined
                v-model="project.accountId"
                :items="accounts"
                item-text="name"
                item-value="id"
              />
            </v-col>
          </v-row>
          <h2>{{ $t('project.addMembers') }}</h2>
          <v-row
            v-for="(member, index) in project.members"
            :key="index"
          >
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="member.firstName"
                outlined
                :label="$t('global.firstName')"
                required
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="member.lastName"
                outlined
                :label="$t('global.lastName')"
              />
            </v-col>
            <v-col cols="12" sm="6" md="5">
              <v-text-field
                v-model="member.email"
                outlined
                :label="$t('global.email')"
                :rules="[rules.required, rules.email]"
              />
            </v-col>
            <v-col cols="12" sm="6" md="1">
              <v-btn
                color="primary"
                fab
                small
                @click="removeMember(member)"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <div class="text-center">
          <v-btn
            color="primary"
            fab
            @click="addMember"
          >
            <v-icon dark>mdi-account-plus</v-icon>
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="ma-auto">
          <v-btn
            color="primary"
            tile
            @click="validate"
            class="mx-1"
            :disabled="project.name.length === 0 || project.accountId === null"
          >
            {{ $t('global.validate') }}
          </v-btn>
          <v-btn
            color="ternary"
            dark
            tile
            @click="cancel"
            class="mx-1"
          >
            {{ $t('global.cancel') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { testEmail } from '@/utils/utils.js';
import accountService from '@/services/accounts.js';

export default {
  name: 'AddProjectDialog',

  data () {
    return {
      project: {
        members: [],
        name: '',
        accountId: null,
      },
      rules: {
        required: value => !!value || this.$i18n.t('login.rules.required'),
        email: value => {
          return testEmail(value) || this.$i18n.t('login.rules.invalidEmail');
        },
      },
      isAccountLoading: false,
      accounts: [],
    }
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    propProject: {
      type: Object,
      required: false,
      default: () => undefined,
    },
    validateFunction: {
      type: Function,
      required: true,
    },
  },

  methods: {
    validate () {
      this.validateFunction(this.project).finally(() => {
        this.reinitData();
      });
    },

    cancel () {
      this.reinitData();
      this.$emit('cancel-edition');
    },

    addMember () {
      this.project.members.push({});
    },

    removeMember (member) {
      const idx = this.project.members.indexOf(member);
      this.project.members.splice(idx, 1);
    },

    testEmail: testEmail,

    reinitData () {
      this.project = Object.assign({
        members: [],
        name: '',
        accountId: null,
      });
      this.$refs.projectName.resetValidation();
    },

    getAccounts() {
      this.isAccountLoading = true;
      accountService.getAccounts().then((response) => {
        this.accounts= response.data;
      })
      .catch((error) => {
        this.$emit('raison-event', { type: 'error', messages: [error] });
      })
      .finally(() => {
        this.isAccountLoading = false;
      });
      
    }
  },

  watch: {
    open (newValue) {
      if (newValue && this.edit) {
        this.project = Object.assign({}, this.propProject);
        this.project.members = [...this.propProject.members];
      }
    },
  },

  created() {
    this.getAccounts();
  },
};
</script>